// extracted by mini-css-extract-plugin
module.exports = {"dash-empty-label":"dash-empty-label__y2hin","small":"small__+XgPo","medium":"medium__8b8wD","large":"large__AuqQJ"};